module.exports = __webpack_public_path__ + "img/animals_cow.373c8a56.png";